import { WriteRequest } from "~/backendApis/foundation/WriteRequest"

interface Params {
  supplementaryInformation: string
}

export class ChangeSupplementaryInformationWriteRequest extends WriteRequest<void> {
  private readonly endpoint: string =
    "/user_profile/user/edit/supplementary_information/change"
  private readonly params: Params

  constructor(params: Params) {
    super()
    this.params = params
  }

  public post(): Promise<void> {
    return this.apiClient.post(this.endpoint, this.params)
  }
}
